import { Form, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import * as St from './CustomerDataModal.styles';
import { CustomerDataFooter, CustomerDataForm } from './components';
import { useCustomerFormEvents, useLoadCustomerDataForm } from './hooks';

import { CustomerDataModel } from '~/core/models';

type CustomerDataModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const CustomerDataModal = ({ isOpen, handleClose }: CustomerDataModalProps) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<CustomerDataModel>();

  useLoadCustomerDataForm(form);

  const {
    callFormSubmit,
    isSendingEstimateInfo,
    resetFieldsAndClose,
    updateCustomerDataAndEstimate,
  } = useCustomerFormEvents(form, handleClose);

  return (
    <St.Container
      forceRender
      isVisible={isOpen}
      onClose={handleClose}
      content={
        <>
          {isSendingEstimateInfo && (
            <St.LoadingContainer>
              <Spin size="large" />
            </St.LoadingContainer>
          )}

          <St.Header>
            <St.Title>{t('SAVE.MODAL_TITLE.INSTALLATION')}</St.Title>
          </St.Header>
          <St.Description>{t('SAVE.MESSAGES.HEADER')}</St.Description>

          <CustomerDataForm
            form={form}
            isSendingEstimateInfo={isSendingEstimateInfo}
            onConfirmSuccess={updateCustomerDataAndEstimate}
          />

          <St.Required>{t('SAVE.FOOTER.REQUIRED')}</St.Required>

          <St.AddressWarning>
            {t('SAVE.FOOTER.INSTALLATION_DISTANCE')}
          </St.AddressWarning>
        </>
      }
      footer={
        <CustomerDataFooter
          onCancel={resetFieldsAndClose}
          onSubmit={callFormSubmit}
        />
      }
    />
  );
};

export default CustomerDataModal;
